import { useState, useEffect } from "react";
import AgentsAPI from "../../../api/AgentsAPI";

const useFetchAgentDetails = (userId = null) => {
	const [loading, setLoading] = useState(false);
	const [details, setDetails] = useState([]);

	const fetchDetails = async () => {
		setLoading(true);
		try {
			const result = await AgentsAPI.getAgentDetails(userId);
			setDetails(result);
		} catch (error) {
			console.error("Failed to fetch details:", error);
			setDetails([]);
			return { success: false, error: error.message };
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchDetails();
	}, [userId]); // re-fetch whenever userId changes.

	return {
		details,
		loading,
		refetch: fetchDetails,
	};
};

export default useFetchAgentDetails;
